import React from "react";
import { Col, Row } from "react-bootstrap";
import { GoArrowUpRight } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import {
  primaryColor as defaultBgColor,
  textDarkColor as defaultTextDarkColor,
  textLightColor as defaultTextLightColor,
} from "../Constants/Colors";

const GetInTouch = ({
  radius = 60,
  description = "Leverage our expertise to transform your digital presence and elevate your brand.",
  bgColor = defaultBgColor,
  borderColor = defaultTextLightColor,
  textColor = defaultTextDarkColor,
  subTextColor = defaultTextLightColor,
  circleTextColor = defaultTextDarkColor,

}) => {
  const navigate = useNavigate();

  return (
    <Row className="m-auto">
      <Col
        className="m-auto"
        md={10}
        lg={8}
        style={{
          backgroundColor: bgColor,
          color: textColor,
          borderRadius: "16px",
          border: `2px solid ${borderColor}`,
        }}
      >
        <Row className="align-items-center p-2 p-md-1 m-auto justify-content-center">
          <Col md={8} className="text-start" style={{ color: subTextColor }}>
            <h3>Have A Project?</h3>
            <p className="p-0 m-0 mt-lg-3 mt-3">{description}</p>
          </Col>
          <Col md={3} className="text-end mt-3 mt-md-0">
            <div
              style={{
                position: "relative",
                width: radius * 2 + 40,
                height: radius * 2 + 40,
                margin: "auto",
              }}
            >
              {/* Static Center Icon */}
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 2,
                }}
              >
                <GoArrowUpRight
                  size={38}
                  color={subTextColor}
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/careers")}
                />
              </div>

              {/* Rotating SVG Circle with Text */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  animation: "spin 10s linear infinite",
                  zIndex: 1,
                }}
              >
                <svg width="100%" height="100%" viewBox="0 0 250 250">
                  <defs>
                    <path
                      id="circlePath"
                      d={`
                        M 125,125
                        m -${radius},0
                        a ${radius},${radius} 0 1,1 ${radius * 2},0
                        a ${radius},${radius} 0 1,1 -${radius * 2},0
                      `}
                    />
                  </defs>
                  <text
                    fill={textColor}
                    fontSize="20"
                    fontFamily="sans-serif"
                  >
                    <textPath href="#circlePath" startOffset="0%">
                      Get in touch &nbsp;&nbsp;••&nbsp;&nbsp;Hire us&nbsp;&nbsp;••&nbsp;&nbsp;Contact us&nbsp;&nbsp;••
                    </textPath>
                  </text>
                </svg>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default GetInTouch;
